function createHiddenInput(form) {
  const input = document.createElement('input');

  input.type = 'hidden';
  input.name = 'g-recaptcha-response';

  form.appendChild(input);

  return input;
}

function setupRecaptcha(form, siteKey, action) {
  const input = createHiddenInput(form);

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    grecaptcha.enterprise.ready(async () => {
      const token = await grecaptcha.enterprise.execute(siteKey, { action });
      input.value = token;
      form.submit();
    });
  });
}

export function initRecaptcha() {
  const forms = document.querySelectorAll('.js-recaptcha');

  forms.forEach((form) => {
    if (form.dataset.recaptchaEnabled === 'true') {
      const siteKey = form.dataset.siteKey;
      const action = form.dataset.action;

      setupRecaptcha(form, siteKey, action);
    }
  });
}
